// External libraries
import React from 'react';
import { FloatingLabelInput } from '@checkout/react-components';

import { blurHandler } from './handlers';

const AddressAutoPopulationPostalCode = props => {
  return <FloatingLabelInput {...props} blurHandler={blurHandler} />;
};

export { AddressAutoPopulationPostalCode };
